<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Färger
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sajtens kompletta färgpalett. Teal är primärfärg och används konsekvent
      för interaktiva element och accenter.
    </p>
    <div
      class="grid gap-2.5"
      style="grid-template-columns: repeat(auto-fill, minmax(250px, 1fr))"
    >
      <div
        v-for="c in palette"
        :key="c.name"
        class="flex items-center gap-3.5 p-3 rounded-2xl bg-white"
        style="border: 1.5px solid #eceef0"
      >
        <div
          class="w-9 h-9 rounded-[10px] shrink-0"
          :style="{
            backgroundColor: c.hex,
            border: '1px solid rgba(0,0,0,0.06)',
          }"
        />
        <div class="min-w-0">
          <p class="font-[Poppins] font-bold text-[12px] text-[#191c1e] mb-0.5">
            {{ c.name }}
          </p>
          <p class="font-mono text-[11px] text-[#6c7a77] mb-0.5">{{ c.hex }}</p>
          <p
            class="font-[Plus_Jakarta_Sans] text-[11px] text-[#a0b0ae] leading-[1.4]"
          >
            {{ c.role }}
          </p>
        </div>
      </div>
    </div>
    <CodeBlock :code="code" />
  </div>
</template>

<script setup>
import CodeBlock from "../components/CodeBlock.vue";

const code = `/* Primärfärger */
--color-primary: #14b8a6;          /* Teal — knappar, aktiva element */
--color-primary-dark: #0d9488;     /* Hover-tillstånd */
--color-primary-light: rgba(20,184,166,0.10); /* Bakgrunder */

/* Textfärger */
--color-text-1: #191c1e;           /* Rubriker, primär brödtext */
--color-text-2: #3c4947;           /* Brödtext, beskrivningar */
--color-text-3: #6c7a77;           /* Meta-info, etiketter */
--color-text-4: #a0b0ae;           /* Inaktiva element, kanter */

/* Ytfärger */
--color-border: #eceef0;
--color-surface: #f2f4f6;

/* Semantiska */
--color-easy:     #16a34a;
--color-medium:   #f59e0b;
--color-hard:     #ef4444;
--color-liked:    #f43f5e;`;

const palette = [
  {
    name: "Teal — Primär",
    hex: "#14b8a6",
    role: "Accentfärg, knappar, märken, aktiva element",
  },
  { name: "Teal mörk", hex: "#0d9488", role: "Hover-tillstånd för primär" },
  {
    name: "Teal ljus (10 %)",
    hex: "rgba(20,184,166,0.10)",
    role: "Bakgrunder, hover-states",
  },
  { name: "Natt — Text", hex: "#191c1e", role: "Rubriker, primär brödtext" },
  { name: "Skog — Sekundär", hex: "#3c4947", role: "Brödtext, beskrivningar" },
  { name: "Dimma — Tertiär", hex: "#6c7a77", role: "Meta-info, etiketter" },
  { name: "Grå dimma", hex: "#a0b0ae", role: "Inaktiva element, kanter" },
  { name: "Kantlinje", hex: "#eceef0", role: "Dividers, kortgränser" },
  { name: "Yta — Ljus", hex: "#f2f4f6", role: "Sidlayout-bakgrunder" },
  { name: "Vit", hex: "#ffffff", role: "Kortbakgrunder, sidans bas" },
  { name: "Enkel — Grön", hex: "#16a34a", role: "Svårighetsnivå: Enkel" },
  { name: "Medel — Gul", hex: "#f59e0b", role: "Svårighetsnivå: Medel" },
  {
    name: "Avancerad — Röd",
    hex: "#ef4444",
    role: "Svårighetsnivå: Avancerad",
  },
  { name: "Drink — Blå", hex: "#0891b2", role: "Kategori: Dryck" },
  { name: "Hjärta — Ros", hex: "#f43f5e", role: "Aktiv gilla-knapp" },
  { name: "Amber — Varning", hex: "#b45309", role: "Varning-callout text" },
];
</script>
